import PocketBase from "pocketbase";
import { type TypedPocketBase } from "../pocketbase-types";

let serverUrl = process.env.BUN_PUBLIC_SERVER_URL;

console.log(`Using PB: ${serverUrl}`);
const pb = new PocketBase(serverUrl) as TypedPocketBase;

export function usePocketBase() {
  return pb;
}
